import { render, staticRenderFns } from "./PlaylistSongs.vue?vue&type=template&id=774d63c6&scoped=true&"
import script from "./PlaylistSongs.vue?vue&type=script&lang=js&"
export * from "./PlaylistSongs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d63c6",
  null
  
)

export default component.exports